function withNormalization({ validate, normalize, test }) {
  // Avoid duplicated normalization
  const normalizedRules = new WeakMap();

  return {
    validate,
    test({ rule, params }) {
      let normalized = normalizedRules.get(rule);
      if (!normalized) {
        normalized = normalize(rule);
        normalizedRules.set(rule, normalized);
      }
    
      return test({ rule: normalized, params });
    }
  };
}

module.exports = {
  withNormalization,
};
